export const projects = [
  {
    id: 1,
    title: 'AutoRent Pro',
    description: {
      en: 'A car rental management system with dynamic pricing, booking system, and admin dashboard built with Flask and SQLite.',
      de: 'Ein Autovermietungs-Managementsystem mit dynamischer Preisgestaltung, Buchungssystem und Admin-Dashboard mit Flask und SQLite.',
    },
    image: '/Images/projects/autorent.jpg',
    tech: ['Python', 'Flask', 'SQLite', 'Bootstrap'],
  },
  {
    id: 2,
    title: 'Real Estate Scraper',
    description: {
      en: 'Advanced web scraper for German real estate websites with data extraction, cleaning, and export to Excel/CSV.',
      de: 'Fortgeschrittener Web-Scraper für deutsche Immobilien-Websites mit Datenextraktion, Bereinigung und Export nach Excel/CSV.',
    },
    image: '/Images/projects/scraper.jpg',
    tech: ['Python', 'Selenium', 'BeautifulSoup', 'Pandas'],
  },
  {
    id: 3,
    title: 'Discord Music Bot',
    description: {
      en: 'Feature-rich Discord bot with music playback, playlist management, and custom commands using Discord.py.',
      de: 'Funktionsreicher Discord-Bot mit Musikwiedergabe, Playlist-Verwaltung und benutzerdefinierten Befehlen mit Discord.py.',
    },
    image: '/Images/projects/discord-bot.jpg',
    tech: ['Python', 'Discord.py', 'YouTube API', 'MongoDB'],
  },
  {
    id: 4,
    title: 'Smart Desktop Launcher',
    description: {
      en: 'Futuristic desktop launcher with AI-powered search, custom shortcuts, and system monitoring.',
      de: 'Futuristischer Desktop-Launcher mit KI-gestützter Suche, benutzerdefinierten Shortcuts und Systemüberwachung.',
    },
    image: '/Images/projects/launcher.jpg',
    tech: ['Python', 'PyQt6', 'SQLite'],
  },
  {
    id: 5,
    title: 'Keyboard Input Recorder',
    description: {
      en: 'Advanced input recorder with playback functionality, macro support, and modern GUI.',
      de: 'Fortgeschrittener Input-Recorder mit Wiedergabefunktion, Makro-Unterstützung und moderner GUI.',
    },
    image: '/Images/projects/recorder.jpg',
    tech: ['Python', 'PyQt6', 'pynput'],
  },
  {
    id: 6,
    title: 'Portfolio Website',
    description: {
      en: 'Modern, responsive portfolio website with dark mode, multilingual support, and smooth animations.',
      de: 'Moderne, responsive Portfolio-Website mit Dark Mode, mehrsprachiger Unterstützung und flüssigen Animationen.',
    },
    image: '/Images/Portfolio.jpg',
    tech: ['React', 'Tailwind CSS', 'Framer Motion'],
  }
];

export const skills = [
  'Python',
  'JavaScript',
  'React',
  'Flask',
  'FastAPI',
  'Django',
  'Selenium',
  'BeautifulSoup',
  'MongoDB',
  'SQLite',
  'PostgreSQL',
  'Docker',
  'Git',
  'PyQt6',
  'Tkinter',
  'Discord.py',
  'REST APIs',
  'Web Scraping',
  'Automation',
  'Data Analysis',
];
